import React from "react";
import PropTypes from "prop-types";

import "./FieldGroup.css";

export function FieldGroup({ children }) {
  return <div className="field-group">{children}</div>;
}

FieldGroup.propTypes = { children: PropTypes.node };
FieldGroup.defaultProps = { children: undefined };

export default FieldGroup;
